import OvertimeForm from '@/pages/OvertimeForm';
import OvertimeView from '@/pages/OvertimeView';
import OvertimeApproval from '@/pages/OvertimeApproval';

export default [
  {
    path: '/overtime',
    name: 'overtime',
    component: OvertimeForm,
    meta: {
      title: '',
      requiresAuth: true,
      permissions: ['perm_apply_for_overtime'],
    },
  },
  {
    path: '/overtime/:key',
    name: 'overtime.view',
    component: OvertimeView,
    meta: {
      title: '',
      requiresAuth: true,
      permissions: ['perm_view_own_overtime'],
    },
  },
  {
    path: '/overtime-approval/:key',
    name: 'overtime-approval',
    component: OvertimeApproval,
    meta: {
      title: '',
      requiresAuth: true,
      permissions: ['perm_approve_overtime'],
    },
  },
];
